import { Menu } from "@mui/material";

const CustomMenu = ({ children, ...rest }) => {
  return (
    <Menu
    {...rest}
      keepMounted
      slotProps={{
        paper: {
          style: {
            width: "20ch",
          },
        },
      }}
      anchorOrigin={{
        vertical: "bottom", // Posizionamento verticale del menu
        horizontal: "right", // Posizionamento orizzontale del menu
      }}
      transformOrigin={{
        vertical: "top", // Allineamento verticale del popper
        horizontal: "right", // Allineamento orizzontale del popper
      }}>
      {children}
    </Menu>
  );
};

export default CustomMenu;